import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/app/page.tsx");
